import { getFullName, isVariantMatch, isRoleMatch } from './speaker-utils';
const buildRoleChildren = (nameVariant, nameVariantIndex, speaker, locale, filterByMatch) => {
    const roles = nameVariant.roles
        .map((role, index) => {
        return {
            title: role,
            isDefault: index === nameVariant.defaultRoleIndex,
            isMatch: isRoleMatch(speaker.variantPaths, locale, nameVariantIndex, index),
        };
    });
    const sortedRoles = roles.sort((a, b) => {
        if (filterByMatch) {
            const matchDiff = Number(b.isMatch) - Number(a.isMatch);
            if (matchDiff !== 0)
                return matchDiff;
        }
        return Number(b.isDefault) - Number(a.isDefault);
    });
    return sortedRoles;
};
const buildNameVariants = (speaker, localization, locale, filterByMatch) => {
    const nameVariants = localization.nameVariants.map((variant, variantIndex) => {
        var _a, _b, _c;
        const defaultVariant = localization.nameVariants[localization.defaultVariantIndex];
        const defaultRole = variant.defaultRoleIndex >= 0
            ? ((_a = variant.roles[variant.defaultRoleIndex]) !== null && _a !== void 0 ? _a : null)
            : null;
        const roleChildren = buildRoleChildren(variant, variantIndex, speaker, locale, filterByMatch);
        return {
            title: getFullName(variant.firstName, variant.lastName),
            id: speaker.neutralData.uniqueId,
            dbid: speaker.neutralData.uniqueId,
            isDefault: variantIndex === localization.defaultVariantIndex,
            firstName: variant.firstName,
            lastName: variant.lastName,
            defaultNameVariant: {
                firstName: defaultVariant.firstName,
                lastName: defaultVariant.lastName,
            },
            savedInDb: true,
            speakerIdActive: localization.speakerIdActive,
            language: locale,
            captionColor: (_b = speaker.neutralData.customData.captionColor) !== null && _b !== void 0 ? _b : null,
            diarizationCode: null,
            isUnknown: false,
            role: defaultRole,
            isDefaultColor: (_c = speaker.neutralData.customData.isDefaultColor) !== null && _c !== void 0 ? _c : false,
            unmaintainedMetadata: new Map(),
            children: roleChildren.length > 0 ? roleChildren : undefined,
            imageBase64: speaker.neutralData.imageBase64,
            isMatch: isVariantMatch(speaker.variantPaths, locale, variantIndex),
        };
    });
    return nameVariants;
};
export const getSpeakerNodesFromDb = (data, locale, filterByMatch = false) => {
    const speakers = Array.isArray(data) ? data : [data];
    return speakers.flatMap((speaker) => {
        if (locale === undefined || !(locale in speaker.localizations)) {
            return [];
        }
        const localization = speaker.localizations[locale];
        const nodes = buildNameVariants(speaker, localization, locale, filterByMatch);
        return filterByMatch ? nodes.filter((node) => node.isMatch) : nodes;
    });
};
export const getSpeakerNodesFromDocument = (data) => {
    const speakers = Array.isArray(data) ? data : [data];
    return speakers.map((speaker) => {
        var _a;
        const fullName = getFullName(speaker.firstName, speaker.lastName);
        const role = (_a = (speaker.role === '' ? null : speaker.role)) !== null && _a !== void 0 ? _a : null;
        return Object.assign(Object.assign({}, speaker), { title: fullName, isDefault: false, savedInDb: false, speakerIdActive: false, role, children: role !== null
                ? [
                    {
                        title: role,
                    },
                ]
                : undefined });
    });
};
export const getSortedNodes = (dbNodes, docNodes) => {
    return [
        ...docNodes.reverse(),
        ...dbNodes,
    ];
};
